import {
  formatParseFloat,
  formatParseInt,
  formatParsePercent,
} from "../../../../helper/utils/formatting"
import { fixNumber } from "../../../pages/MetricGoal/utils"

export const MGParsePercent = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    style: "unit",
    unit: "percent",
    useGrouping: true,
    minimumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}
export const MGParseInt = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    useGrouping: true,
    minimumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}
export const MGParseFloat = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    useGrouping: true,
    minimumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}

export const convertToFloat = (value: string) => {
  const cleanedValue = value
    ? parseFloat(
        value?.replaceAll(",", "").replaceAll("$", "").replaceAll("%", ""),
      )
    : 0.0
  return cleanedValue
}
export const convertToInt = (value: string) => {
  return value ? parseInt(value?.replaceAll(",", "")) : 0
}

export const roundUp = (value: string, type: string, precision?: any) => {
  return type === "%"
    ? formatParsePercent(value, precision)
    : type === "#"
    ? formatParseInt(value, precision)
    : type === "$"
    ? formatParseFloat(value, precision)
    : value
}

export const getLevelSum = (params: any) => {
  const {
    levelValues,
    aggType,
    bucket,
    fallbackData,
    precision,
    trendAggType,
  } = params
  const { data, metric } = fallbackData
  const months = [
    "baseline_value",
    "metric_benchmark",
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "june",
    "july",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ]

  const parseFun =
    aggType === "#"
      ? MGParseInt
      : aggType === "%"
      ? MGParsePercent
      : MGParseFloat

  // const precision = aggType === "#" ? 0 : 2
  let partialRowData = null
  // if (
  //   ["$", "#"].includes(aggType) &&
  //   "Production" === bucket // no rolling back in collections?
  //   // [
  //   //   "Net Production vs Goal",
  //   //   "Net Production vs Forecast",
  //   //   "Collections $",
  //   // ].includes("one")
  // ) {
  //   console.log({ params })

  //   const pFunc = aggType === "#" ? parseInt : parseFloat
  //   partialRowData = months.reduce((levels: any, month: string) => {
  //     const monthSum = levelValues?.reduce((sum: number, item: any) => {
  //       sum += pFunc(item?.[month] || "0")
  //       return sum
  //     }, 0)

  //     if (!monthSum) {
  //       if (month === "baseline_value" || month === "metric_benchmark") {
  //         levels[month] = "Not Available"
  //       } else {
  //         levels[month] = null
  //       }
  //     } else {
  //       levels[month] = parseFun(monthSum, precision)
  //     }

  //     return levels
  //   }, {})
  // }

  const baseFields = {
    baseline_value: metric?.group?.baseline_value
      ? parseFun(metric?.group?.baseline_value, precision)
      : "Not Available",
    metric_benchmark: metric?.metric_benchmark
      ? parseFun(metric?.metric_benchmark, precision)
      : // parseFloat(metric?.metric_benchmark)
        "Not Available",
    trend_value: metric?.group?.trend_value
      ? fixNumber(metric?.group?.trend_value, metric?.trend_type, precision)
      : "Not Available",
    year_total: 0.0,
  }

  // let count = 0
  partialRowData = months.slice(2).reduce((cols: any, month: string) => {
    cols[month] = data?.goals?.[month]?.goal_value
      ? parseFun(data?.goals?.[month]?.goal_value, precision)
      : null
    // @todo -defer
    // cols["year_total"] = value.toFixed(precision)
    // count += value ? 1 : 0
    return cols
  }, baseFields)

  // @todo -defer
  // if (aggType === "%") {
  //   partialRowData["year_total"] = partialRowData["year_total"] / count
  // }

  return partialRowData
}
